import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class FormService {
  configUrl = 'assets/config.json';

  tab = 'panel1';
  //active = "static-1";
  active = "static-2";
  sc = null;

  //リセット用
  r_input: any = {
    division_code: "",
    sales_contact_code: "",
    customer_code: "",
    customer_no: "",
    contract_no: "",
    customer_name: "",
    joint_name1: "",
    joint_name2: "",
    kana_name: "",
    birthday: "",
    b_year: "",
    b_month: "",
    b_date: "",
    gender: "",
    zip_code: "",
    pref: "",
    city: "",
    address: "",
    tel_number: "",
    fax_number: "",
    mobile_number: "",
    mail_address: "",
    note: "",
    family_name1: "",
    family_relation1: "",
    family_bitrh1: "",
    fb_year1: "",
    fb_month1: "",
    fb_day1: "",
    family_name2: "",
    family_relation2: "",
    family_bitrh2: "",
    fb_year2: "",
    fb_month2: "",
    fb_day2: "",
    family_name3: "",
    family_relation3: "",
    family_bitrh3: "",
    fb_year3: "",
    fb_month3: "",
    fb_day3: "",
    family_name4: "",
    family_relation4: "",
    family_bitrh4: "",
    fb_year4: "",
    fb_month4: "",
    fb_day4: "",
    family_name5: "",
    family_relation5: "",
    family_bitrh5: "",
    fb_year5: "",
    fb_month5: "",
    fb_day5: "",
  };
  r_question: any = {
    family_structure: "",
    parent_num: "",
    children: "",
    children_num: "",
    income: "",
    car: "",
    q_land: "",
    a1: {},
    a1_introducer: "",
    a1_other: "",
    a2_1: "",
    a2_2: "",
    a2_3: "",
    a2_1_introduced: "",
    a2_2_introduced: "",
    a2_3_introduced: "",
    a2_1_memo: "",
    a2_2_memo: "",
    a2_3_memo: "",
    a3: {},
    a3_other: "",
    a4: "",
    a4_memo: "",
    a5: "",
    a5_other: "",
    a6: "",
    a7_1: "",
    a7_1_other: "",
    a7_1_reason: "",
    a7_2: "",
    a7_2_other: "",
    a7_2_reason: "",
    a7_3: "",
    a7_3_other: "",
    a7_3_reason: "",
    a7_4: "",
    a7_4_other: "",
    a7_4_reason: "",
    a7_5: "",
    a7_5_other: "",
    a7_5_reason: "",
    a8: {},
    a8_99: "",
    a8_other: "",
  };
  r_point: any = {
    status: 0,
    rank: 8,
    rank_ob: 0,
    introduction: 0,
    warning: 0,
    total_points: 0,//総ポイント数
    land_points: 0,//土地ポイント数
    land_owner: "",//土地所有
    land_buying: "",//土地_買付申込書
    land_lord_consent: "",//土地_地主の承諾書
    land_public_figure: "",//土地_公図
    land_transcript_land: "",//土地_謄本（土地）
    land_transcript_build: "",//土地_謄本（建物））
    land_survey_land: "",//	土地_測量図（土地）
    land_survey_build: "",//土地_謄本（建物）
    land_value: "",//土地_路線価図
    land_lord_entering: "",//土地_地主の立入許可
    land_survey: "",//土地_現地調査・役所調査
    land_dismantling: "",//土地_解体工事
    land_dismantling_estimate: "",//土地_解体工事見積依頼
    land_preparation: "",//土地_造成工事
    land_preparation_estimate: "",//土地_造成工事見積依頼
    land_sewage: "",//土地_上下水道取出
    land_sewage_estimate: "",//土地_上下水道見積依頼
    land_lease: "",//土地_賃貸借契約
    land_bound: "",//土地_境界確定案内
    land_note: "",//土地_備考
    capital_points: 0,//資金ポイント数
    capital_finance_type: "",//資金_資金種別
    capital_comp: "",//資金_資金成立
    capital_balance_plan: "",//資金_事業収支計画
    capital_identification: "",//資金_本人確認書類（合算者含）
    capital_privacy: "",//資金_個人情報
    capital_health_insurance: "",//資金_健康保険証（合算者含）
    capital_temporary_subsecription: "",//資金_事前審査記入
    capital_temporary_approval: "",//資金_事前審査承認
    capital_loan_consultant: "",//資金_融資打診了解
    capital_rough_finance_plan: "",//資金_概算資金計画内容合意
    capital_finance_plan: "",//資金_資金計画書・見積内容合意
    capital_note: "",//資金_備考
    plan_points: 0,//プランポイント数
    plan_hearing: "",//プラン_ヒアリング
    plan_suggestion: "",//プラン_提案
    plan_confirm: "",//プラン_プラン確定
    plan_law: "",//プラン_法規確認（役所他）
    plan_approval: "",//プラン_承認図書受領
    plan_solar: "",//プラン_太陽光
    plan_note: "",//プラン_備考
    conflict_points: 0,//競合ポイント数
    conflict: "",//競合_競合
    conflict_note: "",//競合_備考
    affected_points: 0,//影響者ポイント数
    affected: "",//影響者_影響者
    affected_note: "",//影響者_備考
    time_points: 0,//時期ポイント数
    time_timing: "",//時期
    time_note: "",//時期_備考
    visit_points: 0,//見学ポイント数
    visit_construct: "",//見学_構造現場
    visit_model: "",//見学_構造現場
    visit_ob: "",//見学_構造現場
    visit_note: "",//見学_備考
    opertor_points: 0,//運営事業者ポイント数
    opertor_open_confirm: "",//運営事業者_出店確認
    opertor_sublease: "",//運営事業者_サブリース契約
    opertor_note: "",//運営事業者_備考
    app_poins: 0,//申込ポイント数
    app_pay: "",//申込_申込（入金済）
    app_note: "",//申込_備考
    loss: "",//失注
    lost_cause1: "",//失注原因
    lost_cause2: "",//失注原因2
    contract_amount: 0,//請負金額
    prospective_sales: 0,//見込売上
    expected_gross_margin: 0,//見込粗利
    finalized_sales: "",//確定売上
    decided_gross_profit: "",//確定粗利
  };
  r_schedule: any = {
    directer_code: "",
    start_hour: "",
    start_minute: "",
    end_hour: "",
    end_minute: "",
    location: "",
    land_area: "",
    finance_application: "",
    construction_payment: "",
    midway_payment: "",
    final_payment: "",
  };

  //都道府県
  Prefectures: string[] = ["", "北海道", "青森県", "岩手県", "宮城県", "秋田県", "山形県", "福島県", "茨城県",
    "栃木県", "群馬県", "埼玉県", "千葉県", "東京都", "神奈川県", "新潟県",
    "富山県", "石川県", "福井県", "山梨県", "長野県", "岐阜県", "静岡県", "愛知県", "三重県",
    "滋賀県", "京都府", "大阪府", "兵庫県", "奈良県", "和歌山県", "鳥取県", "島根県", "岡山県", "広島県",
    "山口県", "徳島県", "香川県", "愛媛県", "高知県", "福岡県", "佐賀県", "長崎県", "熊本県", "大分県", "宮崎県", "鹿児島県", "沖縄県"];

  gender: any = [
    { value: "1", label: "男性" },
    { value: "2", label: "女性" },
    { value: "3", label: "その他" },
  ];

  a1: string[] = [
    'インターネットでの検索',
    'インターネット広告',
    '他人のSNS・ブログでの書き込み',
    'ポスティングチラシ',
    '新聞の折込チラシ',
    '雑誌 Couta[クータ]',
    '常陽リビング',
    '駅看板',
    '路上看板',
    '現地(モデル)看板',
    'スーモカウンター',
    '紹介',
    'その他'
  ];
  /*
  a2: string[] = [
    '当社ホームページ',
    'インターネット検索',
    'インターネット広告',
    '他人のSNS・ブログでの書き込み',
    'ポスティングチラシ',
    '新聞折込チラシ',
    '雑誌 Couta[クータ]',
    '常陽リビング',
    '駅看板',
    '路上看板',
    '現地(モデル)看板',
    'スーモカウンターからの紹介',
    'ダイレクトメール（メール）',
    'ダイレクトメール（郵送）',
    '紹介（親族・友人・勤務先）',
    'その他'
  ];
  */
 a2: string[] = [
  '当社ホームページ',
  'インターネット検索',
  'インターネット広告',
  'Facebook',
  'Instagram',
  '路上に設置してある看板',
  'このお店の看板（のぼり）',
  '新聞折込チラシ',
  'ポスティングチラシ',
  '雑誌 Couta[クータ]',
  '常陽リビング',
  'その他の雑誌',
  'DM（メール）',
  'DM（郵送）',
  '他人のSNS・ブログでの書き込み',
  '現地(モデル)看板',
  'スーモカウンターからの紹介',
  '紹介',
  'その他'
];
/*
a3: string[] = [
    '新聞広告',
    '新聞折込チラシ',
    '電車内の広告',
    'インターネット広告（スマホ）',
    'インターネット広告（PC）',
    'テレビCM',
    'ラジオCM',
    'フリーペーパー',
    '屋外看板（路上）',
  ];
*/
a3: string[] = [
  '新聞広告',
  '新聞折込チラシ',
  'ポスティングチラシ',
  '電車内の広告',
  'インターネット広告（スマホ）',
  'インターネット広告（PC）',
  'テレビCM',
  'ラジオCM',
  'フリーペーパー',
  '屋外看板（路上）',
];
a8: string[] = [
    'プランの依頼をしたい',
    '見積りの依頼をしたい',
    'まずは話を聞きたい',
    'その他'
  ];

  constructor(
    private http: HttpClient,
  ) { }

  /**
   * 指定した年から現在の年までの配列を返す
   */
  formSetYear(start: number) {
    var year = new Date().getFullYear();
    var length = (year - start) + 1;
    var years = Array.apply(null, new Array(length)).map(function (v, i) { return year - i });

    return years;
  }
  formSetYear2(start: number) {
    var year = new Date().getFullYear();
    let month = new Date().getMonth() + 1;
    if (month < 7) {
      year--;
    }
    var length = (year - start) + 1;
    var years = Array.apply(null, new Array(length)).map(function (v, i) { return year - i });

    return years;
  }
  /**
   * 月を返す
   */
  formSetMonth() {
    return ['', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'];
  }
  /**
   * 引数の年と月に合わせた日数を配列で返す
   * @param year 
   * @param month 
   */
  formSetDay(year, month) {
    if (!!year && !!month) {
      var start = 1;
      var lastDay = new Date(year, month, 0).getDate();
      var days = Array.apply(null, new Array(lastDay)).map(function (v, i) { return start + i; });
      days.unshift('');
      return days;
    }
  }

  /**
   * 都道府県一覧取得
   * 先頭に空白が入ります
   */
  getPrefectures() {
    return this.Prefectures;
  }

  /**
   * 郵便番号から検索
   * Promiseで返されます
   */
  searchZip(zip: string) {
    if (zip.length == 7) {
      const zip1 = zip.substr(0, 3);
      var zipAddr = {};

      var httpGet = this.http.get("https://yubinbango.github.io/yubinbango-data/data/" + zip1 + ".js",
        { responseType: 'text' }
      );

      return httpGet.toPromise().then((response) => {
        zipAddr = response.replace(/yubin/g, '').replace("$", '').replace("(", '').replace(")", '');
        zipAddr = (new Function("return " + zipAddr))();
        var addr = zipAddr[zip];
        return addr;
      });
    }
  }

}
